(() => {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function redirectLegacyProductCatalogue() {
    if (window.Shopify?.designMode || window.location.pathname !== '/collections/all-products') return false;
    const legacyFilter = new URLSearchParams(window.location.search).get('filter.p.product_type');
    const careFilters = {
      ears: 'ears',
      eyes: 'eyes',
      dental: 'dental',
      'skin & coat': 'skin-coat',
    };
    const destination = new URL('/collections', window.location.origin);
    const careFilter = careFilters[(legacyFilter || '').toLowerCase()];
    if (careFilter) destination.searchParams.set('care', careFilter);
    destination.hash = window.location.hash;
    window.location.replace(`${destination.pathname}${destination.search}${destination.hash}`);
    return true;
  }

  function initHero(root) {
    if (root.dataset.tplReady) return;
    root.dataset.tplReady = 'true';
    const groups = [...root.querySelectorAll('[data-tpl-hero-group]')];
    const dots = [...root.querySelectorAll('[data-tpl-hero-dot]')];
    if (groups.length < 2) return;
    let active = Math.floor(Math.random() * groups.length);
    let timer;
    const show = (index) => {
      active = (index + groups.length) % groups.length;
      groups.forEach((group, i) => { group.hidden = i !== active; group.classList.toggle('is-active', i === active); });
      dots.forEach((dot, i) => dot.classList.toggle('is-active', i === active));
    };
    const start = () => { if (!reducedMotion) timer = window.setInterval(() => show(active + 1), 6200); };
    const stop = () => window.clearInterval(timer);
    dots.forEach((dot, index) => dot.addEventListener('click', () => { stop(); show(index); start(); }));
    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    root.addEventListener('focusin', stop);
    root.addEventListener('focusout', start);
    show(active);
    start();
  }

  function initCarousel(root) {
    if (root.dataset.tplReady) return;
    root.dataset.tplReady = 'true';
    const slides = [...root.querySelectorAll('[data-tpl-slide]')];
    const dots = [...root.querySelectorAll('[data-tpl-dot]')];
    if (!slides.length) return;
    let active = 0;
    let timer;
    const shouldAutoplay = root.dataset.autoplay !== 'false';
    const show = (index) => {
      active = (index + slides.length) % slides.length;
      slides.forEach((slide, i) => { slide.hidden = i !== active; slide.classList.toggle('is-active', i === active); });
      dots.forEach((dot, i) => dot.classList.toggle('is-active', i === active));
    };
    const start = () => {
      window.clearInterval(timer);
      if (shouldAutoplay && !reducedMotion && slides.length > 1) timer = window.setInterval(() => show(active + 1), Number(root.dataset.interval) || 7000);
    };
    const stop = () => window.clearInterval(timer);
    dots.forEach((dot, index) => dot.addEventListener('click', () => { stop(); show(index); start(); }));
    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    root.addEventListener('focusin', stop);
    root.addEventListener('focusout', start);
    show(0);
    start();
    root.tplCarousel = { show, start, stop, slides };
  }

  function initStockists(root) {
    if (root.dataset.tplReady) return;
    root.dataset.tplReady = 'true';
    const search = root.querySelector('[data-tpl-stockist-search]');
    const cards = [...root.querySelectorAll('[data-stockist-card]')];
    const toggle = root.querySelector('[data-tpl-stockist-toggle]');
    let expanded = false;
    const render = () => {
      const query = (search?.value || '').trim().toLowerCase();
      cards.forEach((card, index) => {
        const matches = !query || (card.dataset.search || '').includes(query);
        card.style.display = matches && (query || expanded || index < 9) ? 'grid' : 'none';
      });
      if (toggle) toggle.hidden = Boolean(query) || cards.length <= 9;
    };
    search?.addEventListener('input', render);
    toggle?.addEventListener('click', () => {
      expanded = !expanded;
      root.classList.toggle('is-expanded', expanded);
      const viewAllLabel = root.dataset.viewAllLabel || 'View all locations';
      const showFewerLabel = root.dataset.showFewerLabel || 'Show fewer';
      toggle.textContent = expanded ? `${showFewerLabel} ↑` : `${viewAllLabel} ↓`;
      render();
    });
    render();
  }

  function initLibrary(root) {
    if (root.dataset.tplReady) return;
    root.dataset.tplReady = 'true';
    const buttons = [...root.querySelectorAll('[data-filter]')];
    const cards = [...root.querySelectorAll('[data-library-card]')];
    buttons.forEach((button) => button.addEventListener('click', () => {
      const filter = button.dataset.filter;
      buttons.forEach((item) => item.classList.toggle('is-active', item === button));
      cards.forEach((card) => { card.hidden = filter !== 'all' && !(card.dataset.tags || '').split(/\s+/).includes(filter); });
    }));
  }

  function initHeaderShop(scope = document) {
    scope.querySelectorAll('.tpl-header__nav > details').forEach((details) => {
      if (details.dataset.tplHoverReady) return;
      details.dataset.tplHoverReady = 'true';
      const canHover = window.matchMedia('(hover: hover) and (pointer: fine)');
      let closeTimer;
      const cancelClose = () => window.clearTimeout(closeTimer);
      details.addEventListener('mouseenter', () => {
        if (!canHover.matches) return;
        cancelClose();
        details.open = true;
      });
      details.addEventListener('mouseleave', () => {
        if (!canHover.matches) return;
        cancelClose();
        closeTimer = window.setTimeout(() => {
          if (!details.matches(':hover') && !details.contains(document.activeElement)) details.open = false;
        }, 280);
      });
      details.addEventListener('focusin', () => {
        cancelClose();
        details.open = true;
      });
      details.addEventListener('focusout', () => {
        cancelClose();
        closeTimer = window.setTimeout(() => {
          if (!details.contains(document.activeElement) && !details.matches(':hover')) details.open = false;
        }, 280);
      });
      details.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
          cancelClose();
          details.open = false;
          details.querySelector('summary')?.focus();
        }
      });
    });
  }

  function initStickyHeader() {
    const announcement = document.querySelector('.shopify-section-group-header-group.announcement-bar-section');
    const update = () => {
      const height = announcement?.getBoundingClientRect().height || 0;
      document.documentElement.style.setProperty('--tpl-announcement-height', `${Math.round(height)}px`);
    };
    update();
    if (announcement && !announcement.dataset.tplStickyMeasured) {
      announcement.dataset.tplStickyMeasured = 'true';
      new ResizeObserver(update).observe(announcement);
      window.addEventListener('resize', update, { passive: true });
    }
  }

  function initJudgeMeCarousel(root) {
    if (root.dataset.tplReviewReady) return;
    const track = root.querySelector('.jm-carousel__track');
    const cards = [...root.querySelectorAll('.jm-carousel-review-item')];
    if (!track || cards.length < 2) return;
    root.dataset.tplReviewReady = 'true';
    root.classList.add('tpl-review-carousel');

    const controls = document.createElement('div');
    controls.className = 'tpl-review-carousel__controls';
    controls.innerHTML = '<button type="button" aria-label="Previous reviews">←</button><button type="button" aria-label="Next reviews">→</button>';
    root.prepend(controls);

    const [previous, next] = controls.querySelectorAll('button');
    const step = () => cards[0].getBoundingClientRect().width + 24;
    const move = (direction) => {
      const end = Math.max(0, track.scrollWidth - track.clientWidth);
      let target = track.scrollLeft + (step() * direction);
      if (direction > 0 && target >= end - 4) target = end;
      if (direction < 0 && target <= 4) target = 0;
      track.scrollTo({ left: target, behavior: reducedMotion ? 'auto' : 'smooth' });
    };

    let timer;
    let resumeTimer;
    const stop = () => window.clearInterval(timer);
    const start = () => {
      stop();
      if (reducedMotion) return;
      timer = window.setInterval(() => {
        const end = Math.max(0, track.scrollWidth - track.clientWidth);
        if (track.scrollLeft >= end - 4) track.scrollTo({ left: 0, behavior: 'smooth' });
        else move(1);
      }, 5600);
    };
    const pauseThenResume = () => {
      stop();
      window.clearTimeout(resumeTimer);
      resumeTimer = window.setTimeout(start, 8500);
    };

    previous.addEventListener('click', () => { move(-1); pauseThenResume(); });
    next.addEventListener('click', () => { move(1); pauseThenResume(); });
    track.addEventListener('wheel', pauseThenResume, { passive: true });
    track.addEventListener('pointerdown', pauseThenResume, { passive: true });
    track.addEventListener('touchstart', pauseThenResume, { passive: true });
    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    root.addEventListener('focusin', stop);
    root.addEventListener('focusout', pauseThenResume);
    start();
  }

  function initJudgeMeCarousels(scope = document) {
    scope.querySelectorAll('.jdgm-review-widget .jm-carousel').forEach(initJudgeMeCarousel);
  }

  function initShopGrid(root) {
    if (root.dataset.tplReady) return;
    root.dataset.tplReady = 'true';
    const buttons = [...root.querySelectorAll('[data-shop-filter]')];
    const cards = [...root.querySelectorAll('[data-shop-card]')];
    const list = root.querySelector('[data-shop-list]');
    const count = root.querySelector('[data-shop-count]');
    const sort = root.querySelector('[data-shop-sort]');
    let activeFilter = 'all';
    const updateCount = () => {
      if (count) count.textContent = String(cards.filter((card) => !card.hidden).length);
    };
    buttons.forEach((button) => button.addEventListener('click', () => {
      const filter = button.dataset.shopFilter;
      activeFilter = filter;
      buttons.forEach((item) => {
        const selected = item === button;
        item.classList.toggle('is-active', selected);
        item.setAttribute('aria-pressed', String(selected));
      });
      cards.forEach((card) => {
        card.hidden = filter !== 'all' && card.dataset.category !== filter;
      });
      updateCount();
    }));
    const requestedFilter = new URLSearchParams(window.location.search).get('care');
    const requestedButton = buttons.find((button) => button.dataset.shopFilter === requestedFilter);
    if (requestedButton) requestedButton.click();
    else buttons.forEach((button, index) => button.setAttribute('aria-pressed', String(index === 0)));
    sort?.addEventListener('change', () => {
      const sorted = [...cards].sort((a, b) => {
        if (sort.value === 'title-ascending') return a.dataset.title.localeCompare(b.dataset.title);
        if (sort.value === 'price-ascending') return Number(a.dataset.price) - Number(b.dataset.price);
        if (sort.value === 'price-descending') return Number(b.dataset.price) - Number(a.dataset.price);
        return Number(a.dataset.featuredOrder) - Number(b.dataset.featuredOrder);
      });
      sorted.forEach((card) => list?.appendChild(card));
      cards.forEach((card) => { card.hidden = activeFilter !== 'all' && card.dataset.category !== activeFilter; });
      updateCount();
    });
    updateCount();
  }

  function initAll(scope = document) {
    if (redirectLegacyProductCatalogue()) return;
    initStickyHeader();
    initHeaderShop(scope);
    initJudgeMeCarousels(scope);
    scope.querySelectorAll('[data-tpl-hero-rotator]').forEach(initHero);
    scope.querySelectorAll('[data-tpl-carousel]').forEach(initCarousel);
    scope.querySelectorAll('[data-tpl-stockists]').forEach(initStockists);
    scope.querySelectorAll('[data-tpl-library]').forEach(initLibrary);
    scope.querySelectorAll('[data-tpl-shop-grid]').forEach(initShopGrid);
  }

  document.addEventListener('DOMContentLoaded', () => initAll());
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  document.addEventListener('shopify:block:select', (event) => {
    const slide = event.target.closest?.('[data-tpl-slide]');
    const root = slide?.closest('[data-tpl-carousel]');
    if (!root?.tplCarousel) return;
    const index = root.tplCarousel.slides.indexOf(slide);
    root.tplCarousel.stop();
    root.tplCarousel.show(index);
  });
  document.addEventListener('shopify:block:deselect', (event) => {
    event.target.closest?.('[data-tpl-carousel]')?.tplCarousel?.start();
  });

  const appObserver = new MutationObserver(() => initJudgeMeCarousels());
  appObserver.observe(document.documentElement, { childList: true, subtree: true });
})();
